import React, { Fragment, Component } from 'react';
import '../App.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 1,
    };
    this.getImageURL = this.getImageURL.bind(this);
  }

  getImageURL() {
    // TODO: Make this return a new URL every n seconds
    return `${process.env.PUBLIC_URL}/images/Header_${this.state.currentImageIndex}.jpg`;
  }

  render() {
    return (
      <Fragment>
        <div className="row boaa-header">
          <div className="col-lg-7 col-md-12 col-xs-12 col-sm-12">
            <img className="header-side-image" src={this.getImageURL()} alt="Ann Arbor" />
          </div>
          <div className="header-text col-lg-5 ">
            <div className="header-text-year">2019</div>
            <div className="dividing-line" />

            <div className="header-text-title">
            BEST OF
              {' '}
              <br />
              {' '}
            ANN ARBOR
            </div>

            <div className="header-text-description">
              <span>
              You asked for it, Ann Arbor. Here are your favorite eats and treats in the city we call home. Not sure where the best sushi spot is? Or merch stop? Have no fear. The Daily is here. We’ve got words on what locals voted the finest of our town. Whether you find yourself lost on date-night or looking for the perfect Sunday morning sweat session, you’ve come to the right place. Sit back, relax and read all about the best of the very best.
              </span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}


export default Header;
